export default __webpack_public_path__ + "static/media/mor_alkaslasi.abd5712d.png";